import { ref, computed } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { api } from '/app/plugins/services';
import { singleFlight } from '/app/utils/single-flight';

export const useCategories = createSharedComposable(() => {
    const rawCategories = ref([]);
    const categoriesRelationship = ref([]);

    const categories = computed(() => {
        const to = (category, relations) => {
            const info = relations.find(r => r.id === category.category);
            return {
                id: category.id,
                reference: category.category,
                name: info.name,
                slug: info.slug,
                related_platform: info.related_platform || null,
                description: info.description,
                icon: info.icon.toLowerCase().replace(' ', '-'),
                children: category.subcategories.map(sub => to(sub, relations))
            };
        };
        const putParent = (cats, parent = null) => {
            cats.forEach(c => {
                c.parent = parent;
                if (c.children && c.children.length) {
                    putParent(c.children, c);
                }
            });
        };
        const result = rawCategories.value.map(c => to(c, categoriesRelationship.value));
        putParent(result);
        return result;
    });

    const fetchAll = singleFlight(async (platformId) => {
        try {
            const { data: payload } = await api.challenges.allCategories(platformId);
            rawCategories.value = payload.data;
            categoriesRelationship.value = Object.values(payload.relationships, {});
        } catch (err) {
            console.log(err);
        }
    }, (platformId) => platformId);

    return { categories, fetchAll };
});
